module.exports = __webpack_public_path__ + "img/price-banner-bg.a1e3505b.png";